import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { withApplicationContext } from '../../../../utils/ApplicationContext';
import { noop } from '../../../../utils/noop';
import { getMonthName } from '../utils';
import { DeliveryOptionsContentStyles } from './DeliveryOptionsContent.style';

// const getSubtitle = (type, appCtx, isFreeShippingApplicable, styles) => {
//   const hoyRegex = /hoy/g;
//   const getFreeShippingLabelAmount = _.get(appCtx, 'siteConfig.textDictionary.ENVIO_GRATIS_LABEL_AMOUNT', '$29.990');

//   if (type === 'HomeDelivery') {
//     if (hoyRegex.test(type)) {
//       return (
//         <>
//           <p className="data-subtitle">Si compras hasta las 14:00 horas.</p>
//           <style jsx>{styles}</style>
//         </>
//       );
//     }
//     if (isFreeShippingApplicable) {
//       return (
//         <>
//           <p className="data-subtitle">
//             Envío <span>gratis</span> {`en productos pequeños por compras desde ${getFreeShippingLabelAmount}.`}
//           </p>
//           <style jsx>{styles}</style>
//         </>
//       );
//     }
//   }
//   if (type === 'PickupInStore') {
//     if (hoyRegex.test(type)) {
//       return (
//         <>
//           <p className="data-subtitle">Si compras hasta las 14:00 horas.</p>
//           <style jsx>{styles}</style>
//         </>
//       );
//     }
//     return (
//       <>
//         <p className="data-subtitle">Al pagar podrás seleccionar la fecha para retirar tu pedido.</p>
//         <style jsx>{styles}</style>
//       </>
//     );
//   }
//   return null;
// };

const getHomeDeliveryMessage = ({ title, date, month }) => {
  const lowerTitle = title?.toLowerCase?.() || '';
  const day = parseInt(date, 10);
  const monthName = getMonthName(month);

  if (lowerTitle.includes('hoy') && day && monthName) {
    return `Hoy, ${day} de ${monthName}`;
  }

  if (lowerTitle.includes('mañana') && day && monthName) {
    return `Mañana, ${day} de ${monthName}`;
  }

  if (lowerTitle.includes('desde') && day && monthName) {
    return `Desde el ${day} de ${monthName}`;
  }

  return title;
};

const DeliveryOptionsList = ({ data, setBusy, isFreeShippingApplicable, theme }) => {
  const themedStoresListStyles = DeliveryOptionsContentStyles(theme);
  useEffect(() => {
    setBusy(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filteredData = data.filter((entity) => {
    return entity.show === true;
  });

  return (
    <div className="data-section">
      <div className="data-body">
        {filteredData.slice(0, 4).map((entity) => {
          const { isExpress, timeRange } = entity;
          return (
            <div className="data-list" key={entity.title}>
              <div className="data-entity">
                {isExpress ? (
                  <>
                    <span className="data-title green bold">{entity.title}</span>
                    <span className="data-title">{`, de ${timeRange}`}</span>
                  </>
                ) : (
                  <span className="data-title">{getHomeDeliveryMessage(entity)}</span>
                )}
              </div>
              <div className="data-price">
                <span
                  className={`data-span ${
                    isFreeShippingApplicable && entity.price === 'Gratis' ? 'green bold' : 'bold'
                  }`}
                >{`${entity.price}`}</span>
              </div>
              {/* {getSubtitle(type, appCtx, isFreeShippingApplicable, themedStoresListStyles)} */}
            </div>
          );
        })}
      </div>
      <style jsx>{themedStoresListStyles}</style>
    </div>
  );
};

DeliveryOptionsList.defaultProps = {
  data: [],
  setBusy: noop,
  isFreeShippingApplicable: false,
};

DeliveryOptionsList.propTypes = {
  data: PropTypes.array,
  setBusy: PropTypes.func,
  isFreeShippingApplicable: PropTypes.bool,
  theme: PropTypes.object.isRequired,
};
export default withApplicationContext(withTheme(DeliveryOptionsList));
